import { ScheduledPostShow, ScheduledPostsClient } from 'api/clients/ScheduledPostsClient'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { useQuery, UseQueryOptions } from 'react-query'
import { scheduledPostsKeys } from './scheduledPostsKeys'

interface Props {
  id?: number
}

export const useScheduledPost = ({ id }: Props, options?: UseQueryOptions<ScheduledPostShow, Error>) => {
  const workspaceId = useCurrentWorkspaceId()

  return useQuery<ScheduledPostShow, Error>(
    scheduledPostsKeys.show(id ?? 0), // Here we provide a fallback ID, but it won't be used if `enabled` is false
    async () => {
      if (id === undefined) {
        // This is just a safeguard; this code should not be reachable because the query is disabled if id is undefined.
        throw new Error('scheduledPostId is undefined')
      }
      const res = await ScheduledPostsClient.show({ workspaceId, scheduledPostId: id })
      if (res.type === SUCCESS_RESPONSE_TYPE) {
        return res.data.scheduled_post
      } else {
        throw new Error('Error fetching scheduled post')
      }
    },
    {
      enabled: !!workspaceId && !!id,
      ...options,
    },
  )
}
